import React from 'react';
import { MilestoneFlagIcon } from '../MilestoneFlagIcon';

/**
 * QuestMarker - Assassin's Creed style clean exclamation mark
 * Used for available missions
 */
export const QuestMarker = ({ size = 16, className = '' }) => (
  <svg 
    className={`quest-marker ${className}`}
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none"
  >
    {/* Exclamation mark - tapered body */}
    <path 
      d="M12 3 L14.5 15 L12 16 L9.5 15 Z" 
      fill="white"
    />
    {/* Exclamation mark dot - diamond shape */}
    <path 
      d="M12 18 L14 20 L12 22 L10 20 Z" 
      fill="white"
    />
  </svg>
);

/** Milestone HUD marker — shared purple flag */
export const MilestoneMarker = ({ size = 16, className = '', reached = false }) => (
  <MilestoneFlagIcon
    size={size}
    className={`milestone-marker ${className}`.trim()}
    reached={reached}
  />
);

/**
 * Used for active/in-progress missions
 */
export const ActiveMarker = ({ size = 16, className = '' }) => (
  <svg 
    className={`active-marker ${className}`}
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none"
  >
    {/* Motion lines - left */}
    <path d="M5 8 L8 8" stroke="#38bdf8" strokeWidth="2" strokeLinecap="round" />
    <path d="M4 12 L7 12" stroke="#38bdf8" strokeWidth="2" strokeLinecap="round" />
    <path d="M5 16 L8 16" stroke="#38bdf8" strokeWidth="2" strokeLinecap="round" />
    {/* Exclamation mark - tapered body */}
    <path 
      d="M14 3 L16.5 15 L14 16 L11.5 15 Z" 
      fill="#38bdf8"
    />
    {/* Exclamation mark dot - diamond shape */}
    <path 
      d="M14 18 L16 20 L14 22 L12 20 Z" 
      fill="#38bdf8"
    />
  </svg>
);

/**
 * Clock face — timer-gated missions that are otherwise unblocked.
 */
export const WaitingMarker = ({ size = 16, className = '' }) => (
  <svg
    className={`waiting-marker ${className}`}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
  >
    <circle cx="12" cy="12" r="9" stroke="#fbbf24" strokeWidth="2" />
    <path
      d="M12 7 V12 L15.5 14.5"
      stroke="#fbbf24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/**
 * BlockedMarker - Warning triangle with exclamation
 * Used for blocked missions - indicates something needs attention
 */
export const BlockedMarker = ({ size = 16, className = '' }) => (
  <svg 
    className={`blocked-marker ${className}`}
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none"
  >
    {/* Warning triangle outline */}
    <path 
      d="M12 2 L22 20 L2 20 Z" 
      fill="none"
      stroke="#f87171"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    {/* Exclamation mark body */}
    <path 
      d="M12 8 L12 13" 
      stroke="#f87171"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    {/* Exclamation mark dot */}
    <circle 
      cx="12" 
      cy="17" 
      r="1.5" 
      fill="#f87171"
    />
  </svg>
);

